import React, { useState } from 'react';
import HeadingWithIcon from '../../components/widgets/HeadingWithIcon';
import { useTranslation } from 'react-i18next';
import AccountCompletionForm from '../../components/account/AccountCompletionForm';
import { useDispatch, useSelector } from 'react-redux';
import jwt_decode from "jwt-decode";
import axiosInstance from '../../network/ApiCall';
import ErrorAlert from '../../components/widgets/ErrorAlert';
import { updateAccountState } from '../../features/auth/authSlice';
import { Navigate } from 'react-router';


const AccountCompletion = () => {

  const { t } = useTranslation();

  // Check if we can read any default values from our authentication id token. 
  const auth = useSelector((state) => state.auth);
  const userToken = auth.userToken;
  const idToken = userToken?.id_token ? jwt_decode(userToken.id_token) : null;
  const defaultValues = idToken ? { email: idToken.email, name: idToken.name, phone: idToken.phone } : null;
  const [formState, setFormState] = useState({ success: false, errorMessage: null, submissionDate:null });
  
  const dispatch = useDispatch();

  const onSubmit = (data, e) => {  
    axiosInstance.post("/account/complete", data)
      .then(response => {
        if (response.data.id) {
          dispatch(updateAccountState(response.data));
          setFormState({ success: true, error: null, submissionDate:new Date() });
        } else {
          setFormState({ success: false, error: "Error in response", submissionDate:new Date() });
        }
      })
      .catch(error => {
        setFormState({ success: false, error: t("common:msgUnknownApiError"), submissionDate:new Date() });
      })
  };

  const onError = (errors, e) => console.log("ON ERROR", errors, e);

  if (formState.success) 
    return <Navigate replace to={"/"}/>
  

  // render the page
  return (
    <div className="m-2 m-sm-5">
      

      <div className="card my-5">
        <div className="card-header ">
          <div className="row">
            <div className="col">
              <HeadingWithIcon icon="fa-user-circle">{t('account:completionForm:hdgHeading')}</HeadingWithIcon>
            </div> 
          </div>
        </div>
        <div className="card-body ">

          <div className="row ">
            <div className="text-center mt-5">
              <p>{t('account:completionForm:msgSubtext')}</p>
            </div>
            <div className="col-md-8 offset-md-2 mb-5">

              <ErrorAlert error={formState.error} lastStateUpdate={formState.submissionDate}/>
             {/*    <SuccessAlert message={formState.successMessage} /> */}

              <AccountCompletionForm defaultValues={defaultValues} onSubmit={onSubmit} onError={onError} />

            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AccountCompletion;